import SectionHeader from "@/components/base/SectionHeader";
import CTAButton from "@/components/base/CTAButton";

export default function WebsiteOrSoftware() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px]">
        <SectionHeader
          align="center"
          eyebrow="Not Sure What You Need?"
          title="You don't need to know what technology to build."
          subtitle="Tell us what you're trying to achieve, and we'll help you determine the right solution."
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Website card */}
          <div className="rounded-lg border border-background-200 bg-background-50 p-8 md:p-10 flex flex-col transition-all duration-300 hover:border-primary-300 hover:-translate-y-1">
            <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-50 text-primary-600">
              <i className="ri-global-line text-2xl"></i>
            </span>
            <h3 className="mt-6 font-heading text-2xl font-bold text-foreground-950">
              I Need a Website
            </h3>
            <p className="mt-3 text-foreground-600 leading-relaxed">
              I need a professional online presence for my business or
              organization.
            </p>
            <div className="mt-auto pt-8">
              <CTAButton to="/contact" variant="dark" icon="ri-arrow-right-up-line">
                Build My Website
              </CTAButton>
            </div>
          </div>

          {/* Business problem card */}
          <div className="rounded-lg border border-primary-500/40 bg-background-100 p-8 md:p-10 flex flex-col text-foreground-950 transition-all duration-300 hover:-translate-y-1">
            <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-foreground-950">
              <i className="ri-lightbulb-line text-2xl"></i>
            </span>
            <h3 className="mt-6 font-heading text-2xl font-bold">
              I Have a Business Problem
            </h3>
            <p className="mt-3 text-foreground-600 leading-relaxed">
              I have a process, workflow or operational challenge that
              technology could solve.
            </p>
            <div className="mt-auto pt-8">
              <CTAButton to="/contact" variant="primary" icon="ri-arrow-right-up-line">
                Let's Solve It
              </CTAButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}